"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileImageThemes = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var ProfileImageThemes;
(function (ProfileImageThemes) {
    ProfileImageThemes["singlePage"] = "singlePage";
    ProfileImageThemes["desktopBox"] = "desktopBox";
    ProfileImageThemes["desktopMobileBox"] = "desktopMobileBox";
    ProfileImageThemes["appointmentDetails"] = "appointmentDetails";
})(ProfileImageThemes = exports.ProfileImageThemes || (exports.ProfileImageThemes = {}));
var sizeSwitcher = function (theme, bordered, rounded) {
    switch (theme) {
        case ProfileImageThemes.desktopBox:
            return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 60px;\n        height: 60px;\n        border: ", ";\n        ", ";\n      "], ["\n        width: 60px;\n        height: 60px;\n        border: ", ";\n        ", ";\n      "])), bordered ? "3px solid ".concat(b2c_theme_1.colors.white) : 'none', rounded ? 'border-radius: 35px' : '');
        case ProfileImageThemes.desktopMobileBox:
            return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 100px;\n        height: 100px;\n        border: ", ";\n        ", ";\n      "], ["\n        width: 100px;\n        height: 100px;\n        border: ", ";\n        ", ";\n      "])), bordered ? "3px solid ".concat(b2c_theme_1.colors.white) : 'none', rounded ? 'border-radius: 50px' : '');
        case ProfileImageThemes.appointmentDetails:
            return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: 82px;\n        height: 82px;\n        border: ", ";\n        ", ";\n      "], ["\n        width: 82px;\n        height: 82px;\n        border: ", ";\n        ", ";\n      "])), bordered ? "3px solid ".concat(b2c_theme_1.colors.white) : 'none', rounded ? 'border-radius: 50%' : '');
        default:
            return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        width: 125px;\n        height: 125px;\n        border: ", ";\n        ", ";\n      "], ["\n        width: 125px;\n        height: 125px;\n        border: ", ";\n        ", ";\n      "])), bordered ? "3px solid ".concat(b2c_theme_1.colors.white) : 'none', rounded ? 'border-radius: 70px' : '');
    }
};
var ProfileImageElement = styled_components_1.default.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  // TODO add colour picker or auto color based on characters like b2b site\n  background: ", ";\n"], ["\n  ", ";\n  // TODO add colour picker or auto color based on characters like b2b site\n  background: ", ";\n"])), function (_a) {
    var bordered = _a.bordered, rounded = _a.rounded, theme = _a.theme;
    return sizeSwitcher(theme, bordered, rounded);
}, b2c_theme_1.colors.white);
var TextElement = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  // TODO add colour picker or auto color based on characters like b2b site\n  background: ", ";\n"], ["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  // TODO add colour picker or auto color based on characters like b2b site\n  background: ", ";\n"])), function (_a) {
    var bordered = _a.bordered, rounded = _a.rounded, theme = _a.theme;
    return sizeSwitcher(theme, bordered, rounded);
}, b2c_theme_1.colors.primaryColor);
var InitialsSpan = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  padding-top: 0.4rem;\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  padding-top: 0.4rem;\n"])), b2c_theme_1.fonts.defaultBold, function (_a) {
    var theme = _a.theme;
    switch (theme) {
        case ProfileImageThemes.desktopBox:
            return '2rem';
        case ProfileImageThemes.desktopMobileBox:
            return '4rem';
        default:
            return '5rem';
    }
}, b2c_theme_1.colors.white);
var ProfileImage = function (props) {
    var defaultProps = {
        alt: '',
        bordered: true,
        theme: ProfileImageThemes.singlePage,
        rounded: true,
    };
    var _a = __assign(__assign({}, defaultProps), props), alt = _a.alt, bordered = _a.bordered, className = _a.className, rounded = _a.rounded, theme = _a.theme, text = _a.text, url = _a.url;
    var _b = (0, react_1.useState)(null), initials = _b[0], setInitials = _b[1];
    (0, react_1.useEffect)(function () {
        if (text && text.length) {
            var parts = text.toUpperCase().split(' ');
            if (parts.length > 1) {
                setInitials([parts[0].charAt(0), parts[parts.length - 1].charAt(0)].join(''));
                return;
            }
            setInitials(parts[0].charAt(0));
        }
    }, [text]);
    if (url) {
        return (react_1.default.createElement(ProfileImageElement, { alt: alt, bordered: bordered, className: className, "data-testid": "profile-image-element", rounded: rounded, theme: theme, src: url }));
    }
    return (react_1.default.createElement(TextElement, { bordered: bordered, className: className, "data-testid": "profile-text-element", rounded: rounded, theme: theme },
        react_1.default.createElement(InitialsSpan, { "data-testid": "profile-text-span", theme: theme }, initials)));
};
exports.default = ProfileImage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ProfileImage.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/ProfileImage/ProfileImage.js
// module id = 1498
// module chunks = 1 5 16 17 19 20